import { useEffect, useState, Fragment } from 'react'; 
import { Tooltip } from "@material-tailwind/react";
import axios from 'axios';
import ListToggle from './ListToggle';

function Tizenbo() {
    const [data, setDate] = useState([])
    const [search, setSearch] = useState('');

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/InterfaceTizenDevice`)
            .then(res => {
                setDate(res.data)
            }).catch(err => console.log(err))
    }, [])

    const scrollToTop = () =>{ 
        window.scrollTo({ 
          top: 0,  
          behavior: 'smooth'
        }); 
      };

    const arr = data.filter((item) => {
        return search.toLowerCase() === '' 
            ? item 
            :  item._client_name.toLowerCase().includes(search.toLowerCase()) || item._video_url.toLowerCase().includes(search.toLowerCase()) || item._video_url_2.toLowerCase().includes(search.toLowerCase()) || item._video_url_3.toLowerCase().includes(search.toLowerCase()) || item._pin_code.toLowerCase().includes(search.toLowerCase())
    })
    
    .map((data, index) => {
        let dateToCheck = Date.parse(data._last_seen);
        let dateFormat = new Date(dateToCheck).toLocaleString('fr-FR');



        function isOnline(){
            let today = new Date();
            let lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
            
            if ((Date.now() - dateToCheck) <= (5 * 60 * 1000)) {
                return <Tooltip content={dateFormat} className="text-white bg-slate-600 p-2"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAM0lEQVR4nGNgGAXDAjgcCP+PDY9aQL0gciBgwKgFDBQHEaUGOIxa4DAaRA5DPhWNggEFAH2q+KATEHLKAAAAAElFTkSuQmCC" alt="Last seen"></img></Tooltip>
            } else if (dateToCheck < lastWeek) {
                return <Tooltip content={dateFormat} className="text-white bg-slate-600 p-2"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAARUlEQVR4nGNgGAXDAvwKCvqPDQ89Cxhw8Afegl8EgmDoWMBAJp/2FvyiMAh+DRoLGGjEZxi14Be1IvkXmfK0t2AUDCgAANhItxh18JiWAAAAAElFTkSuQmCC" alt="Last seen"></img></Tooltip>
            } else {
                return <Tooltip content={dateFormat} className="text-white bg-slate-600 p-2"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPUlEQVR4nGNgGAXDAvytE/mPDQ89Cxhw8Afegr8EgmDUAgaKg4hYA/6OWvB3NIhonYr+4irsaG7BKBhQAADzX+qQK+dVHAAAAABJRU5ErkJggg==" alt="Last seen"></img></Tooltip>
            }
        }

        function IconAuth() {
            if (data._authorized === "yes") {
                return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 stroke-lime-500"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            } else {
                return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 stroke-red-500"><path strokeLinecap="round" strokeLinejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            }
        }

        return (
            <div className="max-w-sm bg-slate-300 border border-slate-200 rounded-lg shadow dark:bg-slate-800 dark:border-slate-700 my-2 mx-4 cursor-pointer" >

                <video width="400"
                    height="350"
                    controls
                        >
                    <source src={data._video_url}
                        type="video/mp4"></source>
                </video>
                <div className="p-5">
                    <h5 className="mb-2 text-lg font-bold tracking-tight text-slate-900 dark:text-white whitespace-normal">{data._client_name}</h5>
                    <div className='flex justify-between align center gap-7'>
                        <div>
                            <p className='mb-4'>{data._app_type}</p>
                            {isOnline()}
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 mb-4">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                            </svg>
                            {IconAuth()}
                        </div>
                    </div>
                </div>
            </div>
        )
    })
    return (
        <Fragment>
        <div>
            <div className='max-w-md flex items-center text-center mx-auto my-2 gap-2'>
                <ListToggle />
                <div className="relative flex items-left w-full h-9 rounded-lg focus-within:shadow-lg bg-slate-700 overflow-hidden">
                    <div className="grid place-items-center h-full w-12 text-slate-50">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                    </div>

                    <input
                        className="h-full w-full outline-none text-white pr-2 bg-slate-700 placeholder-slate-50"
                        type="text"
                        id="search"
                        placeholder="Search something.." 
                        onChange={(e) => setSearch(e.target.value)} />
                </div>  
            </div>
            <main className="flex flex-row  mt-4">
                <div className="grid lg:grid-cols-5">
                    {arr}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-6 right-6	cursor-pointer" onClick={() => scrollToTop() }>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
            </main>
        </div>
        </Fragment>
    );
}
export default Tizenbo;